import React from 'react';
import { SkinPageProps } from '../SkinPage';
import styles from './styles/ResponsivePageWithColorBG.scss';

const ResponsivePageWithColorBG: React.FC<SkinPageProps> = ({
  id,
  pageDidMount,
  onClick,
  onDblClick,
  children,
  onMouseEnter,
  onMouseLeave,
}) => {
  return (
    // TODO: replace with <div> when sections will be grouped into main
    <main
      id={id}
      className={styles.root}
      ref={pageDidMount}
      onClick={onClick}
      onDoubleClick={onDblClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className={styles.bg} />
      <div>{children()}</div>
    </main>
  );
};

export default ResponsivePageWithColorBG;
